import { PickingList } from '../../views/PickingList';
import { AccessRestriction, RouteItem } from './interfaces/navigation.interface';

export const RouterConfig: RouteItem[] = [
    {
        listed: false,
        accessRestriction: AccessRestriction.PUBLIC,
        route: {
            path: '/',
            Component: PickingList,
        }
    }
];